import { memo } from 'react';

import { injectIntl, IntlShape } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';

import { LoadedContent } from '../../common/types';

import messages from './i18n';
import ShowMoreLinesButton from './show-more-lines-button';

type OwnProps = {
  intl: IntlShape;
  before: LoadedContent;
  heading: string;
  onShowMoreLines: (isShiftClicked: boolean, shouldExpandDown: boolean) => void;
  isDummyChunk?: boolean;
  isLoadingAbove?: boolean;
  isLoadingBelow?: boolean;
  isFirstChunk: boolean;
  isLastChunk: boolean;
  isMultiChunkExpansionInDiffEnabled?: boolean;
};

export const ChunkHeader = injectIntl(
  memo(
    ({
      intl,
      heading,
      before,
      isLoadingAbove,
      isLoadingBelow,
      onShowMoreLines,
      isDummyChunk,
      isFirstChunk,
      isLastChunk,
      isMultiChunkExpansionInDiffEnabled,
    }: OwnProps) => {
      const expandDownButton = (
        <ShowMoreLinesButton
          hasMoreLines={before.hasMoreLines}
          onShowMoreLines={(isShiftClicked: boolean) =>
            onShowMoreLines(isShiftClicked, true)
          }
          isLoading={!!isLoadingBelow}
          isDummyChunk={isDummyChunk}
          isMultiChunkExpansionInDiffEnabled={
            isMultiChunkExpansionInDiffEnabled
          }
          shouldExpandDown
        />
      );

      const expandUpButton = (
        <ShowMoreLinesButton
          hasMoreLines={before.hasMoreLines}
          onShowMoreLines={(isShiftClicked: boolean) =>
            onShowMoreLines(isShiftClicked, false)
          }
          isLoading={!!isLoadingAbove}
          isDummyChunk={isDummyChunk}
          isMultiChunkExpansionInDiffEnabled={
            isMultiChunkExpansionInDiffEnabled
          }
          shouldExpandDown={false}
        />
      );

      const renderExpandButtons = () => {
        if (isFirstChunk) {
          return expandUpButton;
        } else if (isLastChunk) {
          return expandDownButton;
        } else {
          return (
            <>
              {expandDownButton} {expandUpButton}
            </>
          );
        }
      };
      const renderChunkHeading = () => {
        const headingClassName =
          isFirstChunk || isLastChunk
            ? 'chunk-heading'
            : 'chunk-heading-middle';
        return (
          <div className={headingClassName}>
            {heading}
            {isMultiChunkExpansionInDiffEnabled && before.hasMoreLines && (
              <span className="shift-click-hint-wrapper">
                (
                {intl.formatMessage(messages.shiftClickToExpandAllLines, {
                  Shift: <Lozenge>Shift</Lozenge>,
                })}
                )
              </span>
            )}
          </div>
        );
      };

      return (
        <div className="chunk-heading-wrapper gutter-width-apply-padding-left">
          <div className="show-more-lines-wrapper">{renderExpandButtons()}</div>
          {renderChunkHeading()}
        </div>
      );
    }
  )
);
